import { render } from "./DiagnosisIndex.vue?vue&type=template&id=0776a479"
import script from "./DiagnosisIndex.vue?vue&type=script&lang=js"
export * from "./DiagnosisIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__